import React from 'react'
import PropTypes from 'prop-types'

function displayText(node) {
  if (node.title && node.title.length > 0) {
    return node.title
  }
  if (node.text) {
    return node.text
  }

  return ''
}

function displayTextIsTitle(node) {
  return node.title && node.title.length > 0
}

const TextNode = (props) => {
  const { node } = props
  return (
    <div className="textNode">
      <div className="textNodeContentContainer">
        <div
          className="textNodeContent"
          istitle={displayTextIsTitle(node) ? 'yes' : 'no'}
        >
          {displayText(node)}
        </div>
      </div>
    </div>
  )
}

TextNode.propTypes = {
  node: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
  }),
}

export default TextNode
